module.exports = __webpack_public_path__ + "assets/img/032a393af5fd6817cce40ead4057e94b.png";